// TODO 配置上海 & 浙江paperIds
const rules = []
// [{
//   n: 1,
//   paperIds: [76933, 92733]
// }, {
//   n: 1,
//   paperIds: [92733, 92759]
// }]

const paperScale = {
  // 76933: 0.1,
  // 92759: 0.1
}

const scoreFormate = (score) => {
  return Math.round(score * 10) / 10
}

export default {
  getEstimateScore (paperEstimates) {
    const paperScoreMap = {}
    let ignoredPaperIds = []

    paperEstimates.forEach(estimate => {
      paperScoreMap[estimate.paperId] = estimate.status ? estimate.score : 0
    })

    rules.forEach(rule => {
      const sortedIds = rule.paperIds.sort((a, b) => paperScoreMap[b].score - paperScoreMap[a].score)
      ignoredPaperIds = ignoredPaperIds.concat(sortedIds.slice(rule.n))
    })

    let sum = 0
    paperEstimates.forEach(estimate => {
      if (estimate.status && estimate.paperId && ignoredPaperIds.indexOf(estimate.paperId) === -1) {
        sum += scoreFormate(estimate.score * (paperScale[estimate.paperId] || 1))
      }
    })
    return sum
  },

  getPaperScore (paperEstimate) {
    return scoreFormate(paperEstimate.score * (paperScale[paperEstimate.paperId] || 1))
  }
}



// WEBPACK FOOTER //
// ./src/utils/estimate.js